import { report } from 'process';
import './SearchAndFilter.scss';
import SFActions from './SFActions';
import SFLiveReport from './SFLiveReport';
import SFSearch from './SFSearch';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';

export type ReportType = 'Report' | 'Payable' | 'Other';

type SearchAndFilterProps = {
  searchValue?: string;
  selectedReportType: HoneReportType;
  liveReport?: HoneReportTimeframe | null;
  onSearch?: (search: string) => void;
  onClear?: () => void;
};

const SearchAndFilter = ({
  searchValue = '',
  liveReport = null,
  selectedReportType,
  onSearch,
  onClear,
}: SearchAndFilterProps) => {
  const { enableNewReportTable } = useFlags();
  const reportType: ReportType =
    selectedReportType === 'Income Statement' || selectedReportType === 'P&L Comparison'
      ? 'Report'
      : selectedReportType === 'AP Aging'
        ? 'Payable'
        : 'Other';
  return (
    <div className={classNames('search-and-filter', { ['old-table']: !enableNewReportTable })}>
      <SFSearch searchValue={searchValue} onSearch={onSearch} onClear={onClear} />
      <SFLiveReport timeFrame={liveReport} />
      <SFActions reportType={reportType} selectedReportType={selectedReportType} />
    </div>
  );
};

export default SearchAndFilter;
